import React from 'react';
import { Col, Button } from 'antd';
import { Droppable } from 'react-beautiful-dnd';
import classNames from 'classnames';
import Certification from './Certification';

const ListOfCertifications = ({ columns, certifications, removeCertification, openAddModal, openBrowseModal, loadSamples, sampleCertificationsLoaded }) => {
  const printDroppable = (column) => (
    <Droppable droppableId={column.id}>
      {(provided, snapshot) => {
        const listClass = classNames('list-available', {
          'drag-over': snapshot.isDraggingOver,
        });
        return (
          <div ref={provided.innerRef} {...provided.droppableProps} className={listClass}>
            {column.certificationIds.map((certId, index) => (
              <Certification
                key={certifications[certId].id}
                certification={certifications[certId]}
                index={index}
                removeCertification={removeCertification}
                openAddModal={openAddModal}
                columnId={column.id}
              />
            ))}
            {provided.placeholder}
          </div>
        );
      }}
    </Droppable>
  );

  return (
    <Col xs={24} lg={12} xl={8} className="base-available">
      <h3 className="section-title">Available Certifications</h3>
      <div className="base-available-content">
        <div className="base-available-content-scroll">
          <div className="buttons-container">
            <Button type="primary" onClick={() => openAddModal(null)} className="button">
              Add certification
            </Button>
            <Button onClick={openBrowseModal} className="button">
              Browse
            </Button>
            <Button onClick={loadSamples} disabled={sampleCertificationsLoaded} className="button">
              {sampleCertificationsLoaded ? 'Sample certifications loaded' : 'Load sample certifications'}
            </Button>
          </div>
          {printDroppable(columns.available)}
        </div>
      </div>
    </Col>
  );
};

export default ListOfCertifications;
